<template>
  <div class="residential-main h-full">
  <div class="residential-banner">
    <div class="title-box">
      <div class="title-box-left">
        <div class="title-box-left-main">
          <div class="title-box-left-tit">
            {{ $t('residential_orders.recharge.title') }}
          </div>
          <div class="title-box-left-tip">
            <span id="" v-cloak>{{user_traffic_plan}}</span>
          </div>
        </div>
      </div>
      <div class="title-box-right">
        <div class="btn">
          <a href="/ucenter/residential/">{{ $t('residential_orders.recharge.action') }}</a>
        </div>
      </div>
    </div>
    <div class="title-box active">
      <div class="title-box-left">
        <div class="title-box-left-main">
          <div class="title-box-left-tit">
            {{ $t('residential_orders.traffic.title') }}
          </div>
          <div class="title-box-left-tip">
            <span id="" v-cloak>{{user_traffic_balance}}</span>
            <span class="data" v-show="lastTime != ''"><span v-show="lastTimeName" class="ml-2">{{ $t('residential_orders.traffic.expiry_time') }}</span><span v-cloak>{{lastTime}}</span></span>
          </div>
        </div>
      </div>
      <div class="title-box-right">
        <div class="btn">
          <a href="/ucenter/residential/">{{ $t('residential_orders.traffic.action') }}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="residential-top">
    <el-form
      ref="form"
      :model="form"
      label-position="left"
      class="demo-form-inline"
      :inline="true"
    >
      <el-form-item>
        <el-input
          v-model="form.searchKey"
          :placeholder="$t('residential_orders.form.order_no_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-col :span="12">
          <el-form-item prop="startTime">
            <el-date-picker
              type="datetime"
              :placeholder="$t('residential_orders.form.start_time_placeholder')"
              v-model="form.startTime"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="endTime">
            <el-date-picker
              type="datetime"
              :placeholder="$t('residential_orders.form.end_time_placeholder')"
              v-model="form.endTime"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-select v-model="form.selectPopUp" :placeholder="$t('residential_orders.form.pay_status_placeholder')">
          <el-option
            v-for="(item,key) in selectPopUpList"
            :key="key"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="onSearch" v-cloak>{{ $t('residential_orders.form.search') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="residential-center">
    <div class="list-table">
      <el-table
        :data="tableData"
        :cell-class-name="tableCellClassName"
        style="width: 100%"
        height="100%"
      >
        <el-table-column
          prop="order_no"
          :label="tableName[0]"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="title_table"
          :label="tableName[1]"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.title_table }}</span>
            <el-tag v-if="scope.row.is_free_test" size="mini" type="success" class="free-test-tag">
              {{ $t('residential_orders.free_test.label') }}
            </el-tag>
            <el-tag v-if="scope.row.is_recycle" size="mini" type="warning" class="free-test-tag">
              {{ $t('residential_orders.recycle.label') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="coin_table"
          :label="tableName[2]"
          header-align="center"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="period_table"
          :label="tableName[3]"
          header-align="center"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="money_table"
          :label="tableName[4]"
          header-align="center"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.money_table }}</span>
            <div v-if="scope.row.original_money_table" class="original-money">
              {{ scope.row.original_money_table }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="pay_type"
          :label="tableName[5]"
          header-align="center"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="status_table"
          :label="tableName[6]"
          header-align="center"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="pay_time_table"
          :label="tableName[7]"
          header-align="center"
          align="center"
          width="200"
        >
        </el-table-column>
        <el-table-column
          :label="tableName[8]"
          header-align="center"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <el-tooltip
              popper-class="table-item"
              effect="light"
              :content="operate.export"
              placement="top"
              v-show="scope.row.pay_status_type != 'none'"
            >
              <a
                class="operate"
                href="javascript:;"
                v-show="scope.row.pay_status_type != 'none'"
                @click="clickExportInvoice(scope.row)"
                ><img
                  src="@/assets/index/img/ucenter/static_order/icon_xz.png"
                  alt=""
              /></a>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column header-align="center" width="150px" align="center" v-if="show_pay_column">
          <template slot-scope="scope">
            <div
              class="gopay"
              :id="scope.row.order_no"
              v-show="scope.row.show_pay"
            >
              <p>{{ points_seconds(scope.row.show_pay_time) }}</p>
              <div>
                <a href="javascript:;" @click="gopay(scope.row,scope.$index)"
                  >pay</a
                >
                <a href="javascript:;" @click="gocancel(scope.row,scope.$index)"
                  >cancel</a
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        small
        layout="total, prev, pager, next, sizes"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="curPage"
        :page-size="paginationSize"
        :size="paginationSize"
        :total="paginationTotal"
        :page-sizes="$store.state.userPreferences?.paginationSizes || [10, 20, 50, 100]"
      >
      </el-pagination>
    </div>
  </div>
</div>

</template>

<script>
import {getOrderList,cancelOrder,exportInvoice} from '@/http/api/order'
import {getProxyUser} from '@/http/api/member'
import {utcTimestampToLocalTime, localOrderDayBoundary, changeFlowUnit, formatOrderTraffic } from '@/util/human'

export default {
  name: 'residential-orders',
  components: {
    
  },

  data() {
    return {
      Loading: false,
      show_pay_column: false,

      user_traffic_balance:'--',
      user_traffic_plan:'--',
      lastTimeName:false,
      lastTime:'',
      form:{
          searchKey:'',
          startTime:'',
          endTime:'',
          selectPopUp: "",
      }, 
      
      tableData:[],
      paginationTotal:0,
      curPage:1,
      setIntervalList:{0:"",1:"",2:"",3:"",4:"",5:"",6:"",7:"",8:"",9:"",},//Did not pay the setInterval used store 30 minutes 

      highlight_order_no:'',
      highlightedRows: [],
    }
  },
  inject: ['updateCurrentMenuUrl'],
  computed: {
    tableName(){
      return this.$t('residential_orders.table_name')
    },
    selectPopUpList(){
      return [
          {label: this.$t('residential_orders.form.pay_status.all'), value:""},
          {label: this.$t('residential_orders.form.pay_status.paid'), value:2},
          {label: this.$t('residential_orders.form.pay_status.unpaid'), value:1},
      ]
    },
    operate(){
      return this.$t('residential_orders.operate')
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    paginationSize() {
      return this.$store.state.userPreferences?.paginationSize || 10;
    },
  },
  created() {
    this.updateCurrentMenuUrl('/ucenter/residential/orders');
    this.highlight_order_no = this.$route.query?.orderNo ?? ''
  },
  mounted() {
    if (this.isLogin) {
      this.get_list();
      this.loadTrafficSummary();
    } else {
      location.href='/login/'
    }
  },
  methods: {
    async loadTrafficSummary() {
      this.user_traffic_balance = '--';
      this.user_traffic_plan = '--';
      this.lastTime = '';
      this.lastTimeName = false;
      try {
        const response = await getProxyUser({});
        const info = response.data || {};
        const formatTraffic = (value) => {
          if ((typeof value !== 'number' && typeof value !== 'string') || value === '') return '--';
          const megabytes = Number(value) * 1000;
          return Number.isFinite(megabytes) && megabytes >= 0 ? changeFlowUnit(megabytes) : '--';
        };
        this.user_traffic_plan = formatTraffic(info.plan);
        this.user_traffic_balance = formatTraffic(info.balance);
        const expires = Number(info.expire_time);
        if (String(info.is_inf) === '0' && Number.isFinite(expires) && expires > 0) {
          const date = new Date(expires * 1000);
          if (!Number.isNaN(date.getTime())) {
            this.lastTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            this.lastTimeName = true;
          }
        }
      } catch (_) {
        // Unknown account totals remain unavailable; order history still loads.
      }
    },
    gocancel(row, index){
      let self = this;
      if (row.show_pay){
        let order_no = row.order_no;
        cancelOrder({type: 2, order_no: order_no}).then( res => {
          self.tableData = self.tableData.filter(o => o.order_no !== order_no);

          this.$message.success(self.$t('residential_orders.message.success_cancel'));
        }).catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "cancel order error");
        });
      }else{
        this.$message.error(self.$t('residential_orders.message.error_paid'));
        return false;
      }
    },
    //buy 
    gopay(row,index){
        let self = this;
        if(row.show_pay){
          let item = {
            type: 1,
            order_no: row.order_no,
          }
          this.$router.push({ path: '/payment', query: item })
        }else{
          this.$message.error(self.$t('residential_orders.message.error_paid'));
          return false;
        }
    },
    
    //Remove all the countdown 
    clearInt(){
        let self = this;
        for (const index in self.setIntervalList) {
            if(self.setIntervalList[index]){
                window.clearInterval(self.setIntervalList[index]);
            }
        }
    },
    //Determine whether to show the purchase and buy the remaining time 
    shouldShowPay(){
        let self = this;
        for (const index in this.tableData) {
            if(this.tableData[index].show_pay){
                this.setIntervalList[index] = setInterval(() => {
                    this.tableData[index].show_pay_time--
                    if(this.tableData[index].show_pay_time<=0){
                        this.tableData[index].show_pay=false
                        window.clearInterval(this.setIntervalList[index]);
                    }
                }, 1000);
            }
        }
    },
    //Turn second countdown 
    points_seconds(time){
        let points_time = Math.floor(time/60)
        let seconds_time = time%60
        let points = points_time<10?'0'+points_time:points_time
        let seconds = seconds_time<10?'0'+seconds_time:seconds_time
        return points + ":" + seconds
    },
    onSearch:function(){
        this.get_list(1)  
    },
    get_list:function(page){
        let self = this
        self.clearInt();
        var size = self.paginationSize;
        if (typeof(page) == 'undefined') {
            page = 1;
        }
        self.curPage = page
        let param = {
            page: page, 
            limit: size,
            type: 1,
            order_no: self.form.searchKey,
            start_time: self.form.startTime ? localOrderDayBoundary(self.form.startTime) : '',
            end_time: self.form.endTime ? localOrderDayBoundary(self.form.endTime, true) : '',
            pay_status:self.form.selectPopUp
        }
        self.tableData = []

        getOrderList(param).then(res => {
            let timestamp = res.time
            let obj = res.data

            self.paginationTotal = obj.count

            var list = obj.list;
            for (let i = 0; i < list.length; i++) {
              const isFreeTest = list[i]['order_source'] === 'admin_free_test'
              const isRecycle = list[i]['order_source'] === 'admin_recycle'
              list[i].is_free_test = isFreeTest
              list[i].is_recycle = isRecycle
              let close_time = Number(list[i]['close_time'])
              if(close_time > timestamp && list[i]['pay_status']==1){
                  list[i].show_pay_time = close_time - timestamp - 20
                  list[i].show_pay = true
                  self.show_pay_column = true
              }else{
                  list[i].show_pay_time = 0
                  list[i].show_pay = false
              }
            
              let month = self.$t('residential_orders.days')
              let company = list[i].title
              let title = isFreeTest
                ? self.$t('residential_orders.free_test.title')
                : isRecycle
                  ? self.$t('residential_orders.recycle.title')
                  : self.$t('residential_orders.package', {title: company, total: list[i]['total_price']})
 
              var status
              if (isRecycle) {
                if (String(list[i]['deal_status']) === '3') {
                  status = self.$t('residential_orders.recycle.status.succeeded')
                } else if (String(list[i]['deal_status']) === '4') {
                  status = self.$t('residential_orders.recycle.status.failed')
                } else {
                  status = self.$t('residential_orders.recycle.status.processing')
                }
              } else if (isFreeTest) {
                if (String(list[i]['deal_status']) === '3') {
                  status = self.$t('residential_orders.free_test.status.gifted')
                } else if (String(list[i]['deal_status']) === '4') {
                  status = self.$t('residential_orders.free_test.status.failed')
                } else {
                  status = self.$t('residential_orders.free_test.status.delivering')
                }
              } else if (list[i]['pay_status'] == 2) {
                status = self.$t('residential_orders.pay_status.paid')
              } else if (list[i]['pay_status'] == 1){
                status = self.$t('residential_orders.pay_status.unpaid')
              }else if(list[i]['pay_status'] == 4){
                status = self.$t('residential_orders.pay_status.pay_failure')
              }else if(list[i]['pay_status'] == 3){
                status = self.$t('residential_orders.pay_status.pay_canceld')
              }
              let duration=(list[i]['package_days']);

              if(isRecycle){
                list[i]['pay_type'] = self.$t('residential_orders.recycle.payment')
              } else if(isFreeTest){
                list[i]['pay_type'] = self.$t('residential_orders.free_test.payment')
              } else if(list[i]['pay_type']=='1'){
                list[i]['pay_type']=self.$t('residential_orders.pay_type.stripe')
              } else if(list[i]['pay_type']=='2'){
                list[i]['pay_type']=self.$t('residential_orders.pay_type.alipay')
              } else if(list[i]['pay_type']=='3'){
                list[i]['pay_type']=self.$t('residential_orders.pay_type.balance')
              } else {
                // An unpaid order has not selected a payment channel yet. The
                // legacy value 0 is an internal sentinel, not a display value.
                list[i]['pay_type']='--'
              }

              list[i].pay_status_type = list[i]['pay_status'] != 2 || isFreeTest || isRecycle ? 'none' : 'inline-block';
              list[i].title_table = title
              list[i].coin_table = (isRecycle ? '-' : '') + formatOrderTraffic(Math.abs(Number(list[i]['flow_total'] || 0)))
              list[i].period_table = isRecycle || duration === null || duration === undefined
                ? '--' : duration + month
              list[i].money_table = self.formatOrderAmount(list[i], 'pay_price')
              list[i].original_money_table = !isRecycle && Number(list[i]['total_price']) > Number(list[i]['pay_price']) ? self.formatOrderAmount(list[i], 'total_price') : ''
              list[i].status_table = status
              list[i].pay_time_table = list[i]['pay_time'] == 0 ? '--' : utcTimestampToLocalTime(list[i]['pay_time'] * 1000, 1);
              self.tableData.push(list[i])
            }
            self.shouldShowPay()
        }).catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "get orders error");
        })
    },
    highlightRows() {
      this.highlightedRows = [this.highlight_order_no];
      this.$forceUpdate();
      setTimeout(() => {
        this.highlightedRows = [];
      }, 2000); // 设置为与 CSS transition 时间一致
    },
    tableCellClassName:function({row, column, rowIndex, columnIndex}){
      if (this.highlightedRows.includes(row.order_no)) {
        return 'row-highlight-transition';
      }
      if (row.order_no === this.highlight_order_no) {
        return 'row-highlight';
      }
      return '';
    },
    getCurrencySymbol(currency) {
      return currency === 'cny' ? '¥' : '$';
    },
    formatOrderAmount(order, field) {
      const value = Number(order[field] || 0).toFixed(2);
      return this.getCurrencySymbol(order.pay_currency) + value;
    },
    handleCurrentChange:function(){
        if (this.isLogin) {
            this.get_list(this.curPage)
        } else {
            goto_login();
        }
    },
    handleSizeChange(val) {
      if (this.isLogin) {
        this.$store.commit('updateUserPreference', { paginationSize: val });
        this.get_list(1)
      } else {
        goto_login();
      }
    },
    clickExportInvoice: function(row){
      let self = this
      var param = {
          order_no: row.order_no,
      };
      exportInvoice(param).catch(e => {
        self.$message.error(e.message ?? e.msg ?? "Invoice download failed");
      });
    },
    downloadUrlFile:function (url,id) {
        let self = this
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
            if (xhr.status === 200) {
                self.saveAs(xhr.response, id+'.pdf')
            }
        }
        xhr.send()
    },
    saveAs:function(data, name) {
        var urlObject = window.URL || window.webkitURL || window;
        var export_blob = new Blob([data]);
        var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
        save_link.href = urlObject.createObjectURL(export_blob);
        save_link.download = name;
        save_link.click();
    },
  }
}

</script>

<style scoped lang="scss">
// Highlight styles
.row-highlight-transition {
  background-color: #db2a0f;
  transition: background-color 1s ease-in-out;
}

.row-highlight {
  background-color: #e97a05;
  transition: background-color 2s ease-in-out;
}

// Cell styles
.cell {
  .gopay {
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
      line-height: 0.9;
    }

    a {
      display: inline-block;
      color: #276dfd;
      text-decoration: underline;
      line-height: 1;

      &:first-child {
        margin-right: 10px;
      }
    }
  }
}

.original-money {
  margin-top: 4px;
  color: rgba(17, 24, 46, 0.45);
  font-size: 12px;
  line-height: 1;
  text-decoration: line-through;
}

.free-test-tag {
  margin-left: 6px;
  vertical-align: middle;
}

// Tooltip styles
::v-deep .el-tooltip {
  img {
    display: inline-block;
  }
}

// Main container
.residential-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  // Banner section
  .residential-banner {
    width: 100%;
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    gap: 20px;

    .title-box {
      flex: 1;
      min-width: 300px;
      max-width: 685px;
      min-height: 70px;
      padding: 32px 40px;
      background-color: #ffffff;
      box-shadow: 0px 3px 21px 0px rgba(34,50,101,0.1);
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      color: #223265;

      .title-box-left {
        display: flex;
        align-items: center;
        gap: 26px;

        .title-box-left-icon {
          .noactive { display: block; }
          .active { display: none; }
        }

        .title-box-left-main {
          .title-box-left-tit {
            font: normal 24px/35px 'Poppins-Bold';
          }

          .title-box-left-tip {
            font: normal 40px/56px 'Poppins-Bold';
            
            .data {
              font: 14px 'Poppins-Medium';
              color: #e97a05;
            }

            &.small {
              font-size: 24px;
            }
          }
        }
      }

      .title-box-right {
        display: flex;
        align-items: center;

        .btn {
          width: 120px;
          height: 46px;
          background-color: rgba(39,109,253,0.1);
          border-radius: 8px;
          font: normal 16px/46px 'Poppins-SemiBold';
          color: #276dfd;
          cursor: pointer;

          a {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            text-decoration: none;
            color: inherit;
          }
        }
      }

      &.active {
        background-color: #223265;
        color: #ffffff;

        .title-box-left-icon {
          .noactive { display: none; }
          .active { display: block; }
        }

        .btn {
          background-color: #276dfd;
          color: #ffffff;
        }
      }
    }
  }

  // Responsive styles
  @media (max-width: 1500px) {
    .residential-banner {
      flex-direction: column;

      .title-box {
        width: 100%;
        max-width: none;

        &:not(:first-of-type) {
          margin-top: 20px;
        }
      }
    }
  }

  // Form section
  .residential-top {
    ::v-deep .demo-form-inline {
      > .el-form-item {
        &:first-of-type, &:nth-of-type(3) {
          width: 100%;
          max-width: 266px;
          height: 56px;
          background-color: #f0f2f9;
          border-radius: 10px;

          .el-form-item__content {
            width: 100% !important;
            height: 100% !important;

            .el-input, .el-select {
              width: 100%;
              height: 100%;

              .el-input__inner {
                width: 100%;
                height: 100%;
                background-color: #f0f2f9;
                border-radius: 10px;
                border: none;
                outline: none;
                font-family: "Poppins-Medium";
                font-size: 16px;
                color: #11182e;

                &::placeholder {
                  font-family: "Poppins-Medium";
                  font-size: 16px;
                  color: rgba(204, 204, 204, 0.6);
                }
              }
            }
          }
        }

        &:nth-of-type(2) {
          width: 100%;
          max-width: 556px;

          .el-form-item__content {
            width: 100%;

            .el-form-item {
              width: calc(100% - 12px);

              .el-input {
                .el-input__inner {
                  width: 100%;
                  border: none;
                  padding-left: 45px;
                  height: 56px;
                  background-color: #f0f2f9;
                  border-radius: 10px;
                  font-family: "Poppins-Medium";
                  font-size: 16px;
                  color: #11182e;

                  &::placeholder {
                    font-family: "Poppins-Medium";
                    font-size: 16px;
                    color: rgba(204, 204, 204, 0.6);
                  }
                }

                .el-input__icon {
                  font-size: 24px;
                  font-weight: bold;
                  color: #276dfd;
                  line-height: 56px;
                }
              }
            }
          }
        }

        &:last-of-type {
          width: 100%;
          max-width: 163px;
          height: 56px;

          .el-form-item__content {
            width: 100% !important;
            height: 100% !important;

            .el-button {
              width: 100%;
              height: 100%;
              background-color: #276dfd;
              border-radius: 10px;
              font-family: "Poppins-Medium";
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  // Table section
  .residential-center {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    ::v-deep .list-table {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      padding-bottom: 60px;

      .el-table {
        flex: 1;
        overflow: auto;

        &::before {
          height: 0;
        }

        .el-table__header {
          thead {
            background-color: #dce4fa;
            border-radius: 10px 10px 0 0;

            tr {
              th.el-table__cell {
                background-color: #dce4fa;
                font: normal 16px 'Poppins-Medium';
                color: #11182e;

                &:first-of-type {
                  border-radius: 10px 0 0 0;
                }

                &:nth-of-type(9) {
                  border-radius: 0 10px 0 0;
                }
              }
            }
          }
        }

        .el-table__body {
          tbody {
            tr.el-table__row {
              td.el-table__cell {
                font: 14px 'Poppins-Medium';
                color: rgba(17,24,46,0.6);

                .operate {
                  &:first-of-type { margin-right: 17px; }
                  &:last-of-type { margin-left: 17px; }
                }
              }

              &:nth-child(odd) { background-color: #fcfcfe; }
              &:nth-child(even) { background-color: #f0f2f9; }
            }
          }
        }
      }

      .el-pagination {
        padding: 10px 0;
        text-align: center;
      }
    }
  }
}
</style>
